import { useState, useEffect } from 'react';

function useMediaQuery(min, max) {
    const mediaQuery = window.matchMedia(
        `${min ? `(min-width: ${min}px)` : ''} ${max ? `${min ? 'and' : ''} (max-width: ${max}px)` : ''}`
    );
    const [isMatch, setIsMatch] = useState(mediaQuery.matches);

    useEffect(() => {
        // Function to update state based on the media query result
        function handleBreakpointChange(e) {
            setIsMatch(e.matches);
        }

        // Add event listener
        mediaQuery.addEventListener('change', (e) => setIsMatch(e.matches));

        // Check immediately on mount (important for SSR and initial render)
        handleBreakpointChange(mediaQuery);

        // Clean up
        return () => mediaQuery.removeEventListener('change', handleBreakpointChange);
    }, []);

    return isMatch;
}

export default useMediaQuery;
